module.exports = __webpack_public_path__ + "static/media/Mr.10-Walking.a47d8738.gif";